import { render, staticRenderFns } from "./BannerAnnouncement.vue?vue&type=template&id=099a689c&scoped=true"
import script from "./BannerAnnouncement.vue?vue&type=script&lang=js"
export * from "./BannerAnnouncement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099a689c",
  null
  
)

export default component.exports